module.exports = __webpack_public_path__ + "assets/img/Entrepreneurs_cover.719a3af6-ps.jpg";